module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.de8b743.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.woff
// module id = VrTJ
// module chunks = 10